import {Participant} from '../model/participants/Participant';
import {DOMAIN_VALUE_STATUS_MATCH_FINISH, DOMAIN_VALUE_STATUS_MATCH_OPEN} from '../../assets/domains/domains';
import {Match} from '../model/events/Match';
import {TranslateService} from '@ngx-translate/core';

export class MatchHelper
{
  /**
   * Prüft, ob ein Teilnehmer gegeben ist und kein Freilos oder Refresh ist.
   * @param participant Teilnehmer
   */
  public static isValidParticipant(participant: Participant): boolean
  {
    return participant?.id > 0;
  }

  public static getPreviewResult(match: Match, translate: TranslateService): string
  {
    const validHome = MatchHelper.isValidParticipant(match.participantHome);
    const validGuest = MatchHelper.isValidParticipant(match.participantGuest);

    const hasSets = (match.matchmode.setsBestOf > 1 || match.matchmode.setsTotal > 1) || match.matchReport;
    if (validHome && !validGuest)
      return translate.instant('FINISH_WITHOUT_OPPONENT_RESULT', {value: (hasSets ? this.getMaxSets(match) : this.getMaxLegs(match)) + '-0' });
    else if (!validHome && validGuest)
      return translate.instant('FINISH_WITHOUT_OPPONENT_RESULT', {value: '0-' + (hasSets ? this.getMaxSets(match) : this.getMaxLegs(match)) });
    else return translate.instant('FINISH_WITHOUT_OPPONENT');
  }

  public static getPreviewResult01(match: Match, translate: TranslateService, defaultText: string): string
  {
    const validHome = MatchHelper.isValidParticipant(match.participantHome);
    const validGuest = MatchHelper.isValidParticipant(match.participantGuest);

    if (validHome && !validGuest)
      return translate.instant('FINISH_WITHOUT_OPPONENT_RESULT', {value: '1-0'});
    else if (!validHome && validGuest)
      return translate.instant('FINISH_WITHOUT_OPPONENT_RESULT', {value: '0-1' });
    else return translate.instant(defaultText);
  }

  private static getMaxSets(match: Match): number
  {
    if (match.matchmode?.setsBestOf > 0)
    {
      if (match.matchmode?.setsBestOf % 2 === 0)
        return (match.matchmode?.setsBestOf / 2) + 1;
      else return (match.matchmode?.setsBestOf + 1) / 2;
    }
    else if (match.matchmode?.setsTotal != null && match.matchmode?.setsTotal > 0)
      return match.matchmode?.setsTotal;
    return 1;
  }

  private static getMaxLegs(match: Match): number
  {
    if (match.matchmode?.legsBestOf > 0)
    {
      if (match.matchmode?.legsBestOf % 2 === 0)
        return (match.matchmode?.legsBestOf / 2) + 1;
      else return (match.matchmode?.legsBestOf + 1) / 2;
    }
    else if (match.matchmode?.legsTotal != null && match.matchmode?.legsTotal > 0)
      return match.matchmode?.legsTotal;
    return 1;
  }

  public static isStatusOpen(match: Match): boolean
  {
    return match?.statusCd === DOMAIN_VALUE_STATUS_MATCH_OPEN;
  }
  public static isStatusFinish(match: Match): boolean
  {
    return match?.statusCd === DOMAIN_VALUE_STATUS_MATCH_FINISH;
  }

  public static isTcHome(match: Match, teamId: number): boolean
  {
    return this.isTc(match.participantHome, teamId);
  }
  public static isTcAway(match: Match, teamId: number): boolean
  {
    return this.isTc(match.participantGuest, teamId);
  }
  private static isTc(participant: Participant, teamId: number): boolean
  {
    if (participant?.team?.id === teamId)
      return true;
    else if (participant?.teamSeason?.team?.id === teamId)
      return true;
    else return false;
  }

  public static getTitle(match: Match): string
  {
    if (match.participantHome && match.participantGuest)
    {
      return match.participantHome.displayName + ' - ' + match.participantGuest.displayName +
        ' (' + match.resultStr + ')';
    }

    if (match.participants)
    {
      let s = '#' + match.gameNr + ': ';
      for (const participant of match.participants)
        s += (s.endsWith(': ') ? '' : ', ') + participant.participant.displayName;
      return s;
    }

    if (match.gameNr)
      return '#' + match.gameNr;
    else return '[' + match.id + ']';
  }

  public static getEventId(match: Match): number
  {
    if (match.event?.id > 0)
      return match.event.id;
    else return match.eventId;
  }
}
